import React from 'react'
import PropTypes from 'prop-types'
import { Table as BaseTable, TableHead } from '../Table'
import { DATA_TABLE_HEAD_CLASS, DATA_TABLE_TABLE_CLASS } from './styles'

/*
 * Position:fixed clone of <thead>, rendered when the real <thead> leaves the
 * viewport (vertical scroll). Mirrors per-column widths via <colgroup> so the
 * sticky header lines up with the data rows below.
 */
const CLONE_HEADER_CLASS = 'tw:fixed tw:z-30 tw:overflow-x-auto '
  + 'tw:[scrollbar-width:none] tw:[&::-webkit-scrollbar]:hidden tw:shadow-sm tw:bg-gray-50'

const FloatingHeader = ({
  visible, scrollRef, wrapperRect, scrollWidth, colWidths, onScroll, children
}) => {
  if (!visible || colWidths.length === 0 || scrollWidth <= 0)
    return null
  return (
    <div
      ref={scrollRef}
      className={CLONE_HEADER_CLASS}
      style={{ top: 0, left: wrapperRect.left, width: wrapperRect.width }}
      onScroll={onScroll}
    >
      <BaseTable
        className={DATA_TABLE_TABLE_CLASS}
        hover={false}
        responsive={false}
        style={{ width: `${scrollWidth}px`, tableLayout: 'fixed', marginBottom: 0 }}
        bordered
      >
        <colgroup>
          {colWidths.map((width, index) => <col key={index} style={{ width: `${width}px` }} />)}
        </colgroup>
        <TableHead className={DATA_TABLE_HEAD_CLASS}>{children}</TableHead>
      </BaseTable>
    </div>
  )
}

FloatingHeader.propTypes = {
  children: PropTypes.node.isRequired,
  colWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
  onScroll: PropTypes.func.isRequired,
  scrollRef: PropTypes.shape({}).isRequired,
  scrollWidth: PropTypes.number.isRequired,
  visible: PropTypes.bool.isRequired,
  wrapperRect: PropTypes.shape({
    left: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  }).isRequired
}

export default FloatingHeader
